import React from 'react';
import {
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@cargomatic/ui';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import formatMoney from 'utils/formatters/Money';
import ArrowTopRightOnSquareIcon from '../../../v2/icons/ArrowTopRightOnSquareIcon';
import SignedUrlButton from '../SignedUrlButton';

function CreditMemoTable({ creditMemoList = [] }) {
  const { t } = useTranslation();

  return (
    <div data-testid="div-8769682e" className="overflow-x-auto">
      <Table data-testid="table-632bdc93">
        <TableHeader>
          <TableRow data-testid="tr-d08327ab">
            <TableHead>{t('NAME')}</TableHead>
            <TableHead>{t('AMOUNT')}</TableHead>
            <TableHead>{t('DATE')}</TableHead>
            <TableHead>{t('CREATED_BY')}</TableHead>
            <TableHead>{t('PDF')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {creditMemoList.map(
            ({
              number,
              amount_due: amountDue,
              timestamp: createdDate,
              created_by: createdBy,
              _id: id,
              currency,
            }) => {
              return (
                <CreditMemoRow
                  key={id}
                  number={number}
                  amountDue={amountDue}
                  createdDate={createdDate}
                  id={id}
                  createdBy={createdBy}
                  currency={currency}
                />
              );
            },
          )}
        </TableBody>
      </Table>
    </div>
  );
}

const CreditMemoRow = ({
  amountDue,
  createdBy,
  createdDate,
  id,
  number,
  currency,
}) => {
  return (
    <TableRow data-testid="tr-79b18f87">
      <TableCell data-testid="td-fef41e98">
        <div
          data-testid="div-e5068598"
          className="flex justify-start items-center"
        >
          <a
            data-testid="a-cf2a79dd"
            className="flex justify-start items-center"
            target="_blank"
            href={`/invoices/${id}`}
            rel="noreferrer"
          >
            {number}
            <ArrowTopRightOnSquareIcon className="ml-1 w-5 h-5" />
          </a>
        </div>
      </TableCell>
      <TableCell data-testid="td-d88f99a9">
        <span data-testid="span-b1a39882">
          {formatMoney(amountDue, currency)}
        </span>
      </TableCell>
      <TableCell data-testid="td-da7842ab">
        {moment(createdDate).format('L')}
      </TableCell>
      <TableCell data-testid="td-4b3b0b0d">{createdBy}</TableCell>
      <TableCell data-testid="td-4c264c54">
        <SignedUrlButton foreignKey={id} data-testid="CircleButton-f90285ab" />
      </TableCell>
    </TableRow>
  );
};

export default CreditMemoTable;
